// Marca do Quitaí: balão de conversa em forma de Q, com um check (quitado).
export function LogoMark({ className = "w-9 h-9", title }) {
  return (
    <svg viewBox="0 0 120 120" className={className} role={title ? "img" : undefined}
         aria-label={title} aria-hidden={title ? undefined : true}>
      <circle cx="58" cy="56" r="42" fill="#18B46B" />
      <path d="M96.1 73.7 L104 106 L72.4 95.5 Z" fill="#18B46B" />
      <path d="M38 57 L52 71 L79 41" fill="none" stroke="#04140C" strokeWidth="12"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Marca + nome, com o acento do "í" em verde.
export function LogoWordmark({ className = "text-lg" }) {
  return (
    <span className={`font-outfit font-bold tracking-tight ${className}`}>
      Quita<span className="text-emerald-500">í</span>
    </span>
  );
}
